import ColumnsContent from 'components/Hocs/ColumnsContent/index';

import InfoMaterials from './InfoMaterials';

export default ColumnsContent(InfoMaterials, null, ['']);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/InfoMaterials/index.js